// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__KR4iJ","container-fullscreen":"LoadingSpinner_container-fullscreen__o6Kdi","spinner":"LoadingSpinner_spinner__Q1vlO"};